// extracted by mini-css-extract-plugin
export default {"subtitle":"SummaryComponent_subtitle__3WBJG","buttons":"SummaryComponent_buttons__vxE5X"};